import * as ProfileActionTypes from 'actiontypes/profile';
import ProfileService from 'services/ProfileService';

export const deleteEntryRequest = () => ({
  type: ProfileActionTypes.DELETE_ENTRY_REQUESTED,
});

export const deleteEntrySuccess = (data, entryId) => ({
  type: ProfileActionTypes.DELETE_ENTRY_SUCCESS,
  payload: {
    toDelete: entryId,
  },
});

export const deleteEntryFailure = () => ({
  type: ProfileActionTypes.DELETE_ENTRY_FAILURE,
});

const service = new ProfileService();

/** ----------------------------------------------------------------------------
 * DELETE ENTRY
 -----------------------------------------------------------------------------*/
export default function deleteEntry(entryId) {
  return async (dispatch) => {
    dispatch(deleteEntryRequest());
    try {
      const { data } = await service.deleteEntry(entryId);
      dispatch(deleteEntrySuccess(data, entryId));
      return data;
    } catch (error) {
      dispatch(deleteEntryFailure(error));
      return error;
    }
  };
}